// extracted by mini-css-extract-plugin
export default {"project":"style_project__NB7dV"};